import vmDetailsReducer from "store/reducers/vmDetailsReducer";
import vmStockReducer from "store/reducers/vmStockReducer";
import cartReducer from "store/reducers/cartReducer";
import orderReducer from "store/reducers/orderReducer";
import clDetailsReducer from "./clientDetails.reducer";
import { combineReducers } from "redux";

const appReducer = combineReducers({
  vmDetailsReducer,
  vmStockReducer,
  cartReducer,
  orderReducer,
  clDetailsReducer,
});

const rootReducer = (state, action) => appReducer(state, action);

export default rootReducer;
